import { render, staticRenderFns } from "./editDeclaration.vue?vue&type=template&id=689d0555"
import script from "./editDeclaration.vue?vue&type=script&lang=js"
export * from "./editDeclaration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports